import {Component, computed, input, OnDestroy, OnInit, output, signal} from "@angular/core";
import {IOrderHistoryView, IOrderHistoryViewProduct, IOrderHistoryViewProductDisplayAttribute} from "../orders-models";
import {OrderHistoryCacheService} from "../order-history/order-history-cache.service";
import {Subscription} from "rxjs";
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {ProductUtil} from '../../util/product-util';

@Component({
    selector: "order-history-product",
    templateUrl: "./order-history-product.component.html",
    styleUrls: ['../orders.scss', './order-history-product.component.scss'],
    standalone: false
})
export class OrderHistoryProductComponent extends BaseComponent implements OnInit, OnDestroy {
    readonly viewProduct = input<IOrderHistoryViewProduct>();
    readonly displayAttributes = input<IOrderHistoryViewProductDisplayAttribute[]>([]);
    readonly currencyCode = input<string>();
    readonly orderId = input<number>();
    readonly itemAdded = output<IOrderHistoryViewProduct>();

    readonly isAddingToCart = signal<boolean>(false);

    readonly imageSize = computed(() => this.viewProduct()?.productImages?.length > 1 ? 'XS' : 'TH');

    subscription: Subscription = new Subscription();

    ProductUtil = ProductUtil;

    constructor(userService: UserService,
                loggerService: LoggerService,
                private orderHistoryCacheService: OrderHistoryCacheService
    ) {
        super(userService, loggerService);
    }

    ngOnInit() {
        // item is being added to cart for this order OR if the full order is being added to cart
        this.subscription.add(this.orderHistoryCacheService.productsAddingSubject.subscribe((productsAddingMap) => {
            this.isAddingToCart.set(productsAddingMap?.get(this.orderId())?.some((product) => product.id === this.viewProduct().id && product.mhpId === this.viewProduct().mhpId));
        }));
        this.subscription.add(this.orderHistoryCacheService.orderAddingSubject.subscribe((orderId) => {
            this.isAddingToCart.set(orderId === this.orderId());
        }));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setActiveOrderView() {
        const selectedOrderView: IOrderHistoryView = this.orderHistoryCacheService.findOrderView(this.orderId());
        if (selectedOrderView) {
            this.orderHistoryCacheService.setActiveOrderView(selectedOrderView);
        }
    }
}
